import { CommonModule, NgIf } from '@angular/common';
import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CustomToastComponent } from '../../shared/components/toast/custom-toast.component';
import { ApiError, HttpService } from '../../shared/services/http.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    RouterLink,
    NgIf,
    MatIconModule
  ],
  standalone: true
})
export class ForgotPswdComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('backgroundVideo', { static: false }) backgroundVideo!: ElementRef<HTMLVideoElement>;

  public forgotForm: FormGroup;
  formSubmit: boolean = false;
  isLoading: boolean = false;
  private videoInterval: any;

  constructor(
    private fb: FormBuilder,
    private toaster: ToastrService,
    private route: ActivatedRoute,
    public router: Router,
    private httpService: HttpService,
    private snackBar: MatSnackBar,
  ) {
    this.forgotForm = this.fb.group({
      email: ['', [Validators.required, Validators.pattern(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      ), this.emailDomainValidator]],
    });
  }

  ngOnInit() { }

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
  }

  private emailDomainValidator(control: any) {
    if (!control.value) {
      return null;
    }

    const email = control.value;
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!emailPattern.test(email)) {
      return { invalidEmail: true };
    }

    return null;
  }


  onForgotFormSubmit() {
    this.formSubmit = true;

    // Mark all fields as touched to trigger validation display
    this.forgotForm.markAllAsTouched();

    if (this.forgotForm.valid && !this.isLoading) {
      this.isLoading = true;
      const payload = { email: this.forgotForm.value.email };

      this.httpService.post<any>('auth/forgot-password', payload).subscribe({
        next: (response: any) => {
          this.isLoading = false;
          if (response?.status && response?.message) {
            this.showSuccessToast(response?.message);
            this.formSubmit = false;
            this.forgotForm.reset();
          } else {
            this.showErrorToast(response?.message || 'Request failed');
          }
        },
        error: (error: ApiError) => {
          this.isLoading = false;
          this.showErrorToast(error.message);
        },
      });
    }
  }

  private showSuccessToast(message: string): void {
    this.snackBar.openFromComponent(CustomToastComponent, {
      data: { message },
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: ['no-padding-snackbar', 'success-toast'],
    });
  }

  private showErrorToast(message: string | null | undefined): void {
    if (!message) return;
    this.snackBar.openFromComponent(CustomToastComponent, {
      data: { message },
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: ['no-padding-snackbar', 'error-toast'],
    });
  }
}